import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { create } from 'actions/data'
import { receiveForm } from 'actions/customForm/addOrEdit'
import { API_URL } from 'utils/AllURLs'
import {
  List,
  ListItem,
  Hidden,
  Dialog,
  withMobileDialog,
  withStyles,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import Field from 'components/theme/Field'
import Button from 'components/theme/Button'

const EnterFormNameText = connect(
  state => ({
    formNameLength: state.signupForm.addOrEdit?.values?.formName?.value?.length,
  }),
  null,
)(({ formNameLength }) => (
  <div
    style={{
      color: '#014c94',
      fontSize: 20,
      fontWeight: 'bold',
    }}
  >
    {formNameLength
      ? 'Click the "Create" button before adding fields'
      : 'Enter a form name and then click the "Create" button before adding fields'}
  </div>
))

class CustomIntegrationPreview extends Component {
  state = {
    field_name: '',
    field_label: '',
    description: '',
    dialogOpen: false,
  }

  render() {
    const sections = Object.values(this.props.sectionsByID || {})
    const addFieldComponent = (
      <>
        <div
          style={{
            color: '#014c94',
            fontSize: 20,
            fontWeight: 'bold',
            marginBottom: 5,
          }}
        >
          Add a field
        </div>
        <Field
          value={this.state.field_name}
          handleChange={(property, value) =>
            this.setState({ field_name: value })
          }
          placeholder="field_name"
        />
        <Field
          value={this.state.field_label}
          handleChange={(property, value) =>
            this.setState({ field_label: value })
          }
          placeholder="field_label"
        />
        <Field
          value={this.state.description}
          handleChange={(property, value) =>
            this.setState({ description: value })
          }
          placeholder="description"
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            this.props
              .create({
                entity: {
                  field_name: this.state.field_name.split(' ').join('_'),
                  field_label: this.state.field_label,
                  description: this.state.description,
                },
                entityType: 'customform',
                path: `customform/integration/formId/field`,
                snackbarMessage: 'Successfully added a new field!',
                url: `${API_URL}/customform/integration/${this.props.id}/field`,
              })
              .then(payload => {
                this.setState({
                  field_name: '',
                  field_label: '',
                  description: '',
                  dialogOpen: false,
                })
                this.props.receiveForm(payload)
              })
          }}
        >
          Add field
        </Button>
      </>
    )
    return (
      <>
        <div
          style={{
            height: '100%',
            overflowY: 'auto',
          }}
        >
          {this.props.id && (
            <h1
              style={{
                color: '#014c94',
                marginBottom: 8,
                marginTop: 0,
              }}
            >
              Fields
            </h1>
          )}
          {sections.length ? (
            <>
              <div
                style={{
                  maxHeight: 250,
                  overflow: 'hidden',
                  borderRadius: 35,
                  border: '1px solid gray',
                }}
              >
                <List
                  style={{
                    // border: '1px solid gray',
                    maxHeight: 250,
                    overflowY: 'auto',
                    padding: 0, // borderRadius: 35,
                  }}
                >
                  {sections.map((section, idx) => {
                    const fieldName =
                      section?.contactfield?.field_name ||
                      section?.field?.field_name
                    const fieldLabel = section?.label
                    const fieldDescription = section?.description
                    const fieldType = section?.type
                    return (
                      <ListItem
                        style={
                          idx === 0
                            ? {
                                // borderTopLeftRadius: 35,
                                // borderTopRightRadius: 35,
                                borderBottom: '1px solid gray',
                                borderRight: '1px solid gray',
                              }
                            : idx === sections?.length - 1
                            ? {
                                // borderBottomLeftRadius: 35,
                                // borderBottomRightRadius: 35,
                                borderRight: '1px solid gray',
                              }
                            : {
                                borderBottom: '1px solid gray',
                                borderRight: '1px solid gray',
                              }
                        } // button
                      >
                        {fieldName ? `field_name: ${fieldName}, ` : ''}
                        field_type: {fieldType}
                        {fieldLabel || fieldDescription ? ', ' : ''}
                        {fieldLabel
                          ? `field_label: ${fieldLabel}${
                              fieldDescription ? ', ' : ''
                            }`
                          : ''}
                        {fieldDescription
                          ? `description: ${fieldDescription}`
                          : ''}
                      </ListItem>
                    )
                  })}
                </List>
              </div>
              <div
                style={{
                  marginTop: 5,
                  fontSize: 12,
                  color: 'gray',
                }}
              >
                Your custom integration will automatically include contact
                fields, and any new fields posted by your integration will be
                added automatically as well. You can also manually add new
                fields below.
              </div>
            </>
          ) : null}
          {this.props.id ? (
            <>
              <Hidden smDown>
                <div
                  style={{
                    marginTop: 20,
                  }}
                >
                  {addFieldComponent}
                </div>
              </Hidden>
              <Hidden mdUp>
                <div
                  style={{
                    marginTop: 10,
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => this.setState({ dialogOpen: true })}
                  >
                    Add field
                  </Button>
                </div>
              </Hidden>
            </>
          ) : (
            <EnterFormNameText />
          )}
        </div>
        <Dialog
          fullWidth
          maxWidth="xl"
          fullScreen={this.props.fullScreen}
          open={Boolean(this.state.dialogOpen)}
          onClose={() => this.setState({ dialogOpen: false })}
          aria-labelledby="responsive-dialog-title" // disableBackdropClick
          // disableEscapeKeyDown
          PaperProps={{
            classes: {
              rounded: this.props.classes.rounded,
            },
          }}
        >
          <DialogContent>{addFieldComponent}</DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ dialogOpen: false })
              }}
              color="primary"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

const styles = theme => ({
  rounded: {
    borderRadius: 28,
    overflowY: 'hidden',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      overflowY: 'auto',
    },
  },
})

export default connect(
  state => ({
    sectionsByID: state.customForm.addOrEdit?.sectionsByID,
    id: state.customForm.addOrEdit?.id,
  }),
  dispatch => bindActionCreators({ create, receiveForm }, dispatch),
)(withStyles(styles)(withMobileDialog()(CustomIntegrationPreview)))
